<template>
  <v-dialog v-model="editDialog" persistent scrollable>
    <v-card>
      <v-card-title>reply email</v-card-title>
      <v-card-text style="padding-top: 16px">
        <v-textarea
            v-model="view.message"
            dense
            label="keywords"
            outlined
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="red" small text @click="closeDialog" v-on="on">
              NO
            </v-btn>
          </template>
          <span>cancel</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="blue" small text @click="submit" v-on="on">
              yes
            </v-btn>
          </template>
          <span>Submit</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import utils from "@/mixins/utils";

export default {
  props: {
    editDialog: Boolean,
    myId: {type: String, default: null},
  },
  mixins: [validationMixin, utils],
  data() {
    return {
      view: {
        message: null,
      },
    };
  },
  validations: {
    view: {
      message: {
        required,
      },
    },
  },
  mounted() {
  },
  methods: {
    closeDialog() {
      let payload = {id: this.myId, state: false};
      this.$emit("closeEdit", payload);
    },
    submit() {
      let send_mailing_id = this._decode(this.myId);
      let message = this.view.message;
      let data = {send_mailing_id, message};

      let payload = {id: this.myId, data: data, state: false};
      this.$emit("submitEdit", payload);
    },
  },
};
</script>
